import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const Cell = ({ bold, height, borderBottom, paddingX, paddingY, alignVertical, alignHorizontal, style, children }) => (
  <div
    className={classNames('custom-table__cell', {
      'custom-table__bold': bold,
      'custom-table__h-xs': height === 'xs',
      'custom-table__h-sm': height === 'sm',
      'custom-table__h-md': height === 'md',
      'custom-table__h-lg': height === 'lg',
      'custom-table__border-b-xs': borderBottom === 'xs',
      'custom-table__border-b-sm': borderBottom === 'sm',
      'custom-table__border-b-md': borderBottom === 'md',
      'custom-table__px-xs': paddingX === 'xs',
      'custom-table__px-sm': paddingX === 'sm',
      'custom-table__px-md': paddingX === 'md',
      'custom-table__py-xs': paddingY === 'xs',
      'custom-table__py-sm': paddingY === 'sm',
      'custom-table__py-md': paddingY === 'md',
      'custom-table__align-y-top': alignVertical === 'top',
      'custom-table__align-y-middle': alignVertical === 'middle',
      'custom-table__align-y-bottom': alignVertical === 'bottom',
      'custom-table__align-x-left': alignHorizontal === 'left',
      'custom-table__align-x-center': alignHorizontal === 'center',
      'custom-table__align-x-right': alignHorizontal === 'right',
    })}
    style={style}
  >
    {children}
  </div>
);

Cell.defaultProps = {
  bold: false,
  borderBottom: 'xs',
  paddingX: 'sm',
  paddingY: 'sm',
  alignVertical: 'middle',
  alignHorizontal: 'left',
  style: {},
};

Cell.propTypes = {
  bold: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  borderBottom: PropTypes.string,
  paddingX: PropTypes.string,
  paddingY: PropTypes.string,
  alignVertical: PropTypes.string,
  alignHorizontal: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
}
